import { assign, createMachine, InterpreterFrom, StateConfig, StateFrom } from 'xstate'

import { OnboardingData, OnboardingPatientUserMetadata } from '../types'

export type OnboardPatientContext = OnboardingData &
  OnboardingPatientUserMetadata & { customerId?: string }

export type OnboardPatientEvent =
  | { type: 'RESTORE' }
  | { type: 'CONTINUE' }
  | { type: 'UPDATE_FIELDS'; data: Partial<OnboardPatientContext> }

export type OnboardPatientState = {
  value: 'initial' | 'createAccount' | 'invalid' | 'complete'
  context: OnboardPatientContext
}

export type OnboardPatientMachine = typeof machine
export type OnboardPatientInterpreter = InterpreterFrom<typeof machine>
export type OnboardPatientObserverCallback = (state: StateFrom<typeof machine>) => void
export type OnboardPatientStateConfig = StateConfig<OnboardPatientContext, OnboardPatientEvent>
export type OnboardPatientStateObject = StateFrom<typeof machine>
export type OnboardPatientStateValue = OnboardPatientState['value']

export const machine = createMachine<
  OnboardPatientContext,
  OnboardPatientEvent,
  OnboardPatientState
>({
  predictableActionArguments: true,
  id: 'onboard_customer',
  initial: 'initial',
  context: {
    hasPractitioner: undefined,
    firstName: '',
    lastName: '',
    phone: '',
  },
  states: {
    initial: {
      on: {
        '*': [
          {
            cond: ({ customerId }) => Boolean(customerId),
            target: 'complete',
          },
          {
            cond: ({ customerId }) => !customerId,
            target: 'createAccount',
          },
        ],
      },
    },
    createAccount: {
      on: {
        CONTINUE: 'complete',
      },
    },
    invalid: {
      on: {
        RESTORE: 'complete',
      },
    },
    complete: {
      entry: 'submit',
      type: 'final',
    },
  },
  on: {
    UPDATE_FIELDS: {
      actions: assign((context, event) => ({
        ...context,
        ...(event.type === 'UPDATE_FIELDS' ? event.data : {}),
      })),
    },
  },
})
